import { render } from "./ButtonArrowIcon.vue?vue&type=template&id=9026676c"
const script = {}

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__